import type { OrderStatus, OrderType } from '../models/order.model';

const MEAL_COMPLETE_STATUSES = new Set<OrderStatus | string>(['Delivered', 'Fully Delivered']);

export const isOrderMealComplete = (
  orderStatus: OrderStatus | string | null | undefined,
): boolean => {
  if (!orderStatus) {
    return false;
  }
  return MEAL_COMPLETE_STATUSES.has(orderStatus);
};

/** Show the in-page review nudge on order tracking / success screens. */
export const shouldPromptOrderReviewOnOrderPage = (
  orderType: OrderType | string | null | undefined,
  orderStatus: OrderStatus | string | null | undefined,
): boolean => {
  if (!orderType || !orderStatus) {
    return false;
  }
  if (orderType === 'Pre-Order') {
    return false;
  }
  if (orderType === 'Dine-In') {
    return isOrderMealComplete(orderStatus);
  }
  return isOrderMealComplete(orderStatus);
};

/** Show review CTA on my-orders for completed visits. */
export const canPromptReviewFromOrderList = (
  orderType: OrderType | string,
  statusCategory: 'in-progress' | 'delivered' | 'cancelled',
): boolean => {
  if (statusCategory !== 'delivered') {
    return false;
  }
  return orderType !== 'Pre-Order';
};

/** Homepage / session re-engagement: pick the most recent reviewable order. */
export const isHomepageReviewCandidate = (
  orderType: OrderType | string | null | undefined,
  orderStatus: OrderStatus | string | null | undefined,
): boolean => shouldPromptOrderReviewOnOrderPage(orderType, orderStatus);
